import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";
import { pbomListColumns } from "@patronix/domain/list";
import { pbomListQuery } from "@/features/pbom/api";
import { PbomListPage } from "@/features/pbom/PbomListPage";
import { validatePbomSearch, type PbomSearch } from "@/features/pbom/search";
import { activeCompanyOf } from "@/lib/activeCompany";
import { viewQuery } from "@/lib/listView";
import { sessionContextQuery } from "@/lib/session";

export const Route = createFileRoute("/_app/engineering/production-boms")({
  validateSearch: validatePbomSearch,
  loaderDeps: ({ search }) => ({ status: search.status, q: search.q, f: search.f, s: search.s }),
  loader: async ({ context, deps }) => {
    const ctx = await context.queryClient.ensureQueryData(sessionContextQuery);
    const companyId = activeCompanyOf(ctx)?.id;
    if (companyId) {
      await context.queryClient.ensureInfiniteQueryData(
        pbomListQuery(companyId, { status: deps.status, q: deps.q, ...viewQuery(pbomListColumns, deps) }),
      );
    }
  },
  component: Page,
});

function Page() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  const setSearch = useCallback(
    (patch: Partial<PbomSearch>) => void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: true }),
    [navigate],
  );
  return <PbomListPage search={search} setSearch={setSearch} />;
}
